export default __webpack_public_path__ + "static/InterDisplay-Black-2cf94bb300411c663d9d260533ef35b5.woff2";